import {useHistory, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import NotificationTemplateForm from "../../../components/NotificationTemplates/NotificationTemplateForm";
import {toast} from "react-toastify";
import {handleError} from "../../../utils/SharedFunctions";
import {getNotificationTemplate, updateNotificationTemplate} from "../../../Api/ApiCalls";

const EditNotificationTemplatePage = () => {
    const {id} = useParams();
    const history = useHistory();
    const [initialValues, setInitialValues] = useState(null);

    useEffect(() => {
        getNotificationTemplate(id).then((data) => {
            setInitialValues({
                titleEn: data.titleEn || "",
                bodyEn: data.bodyEn || "",
                titleNl: data.titleNl || "",
                bodyNl: data.bodyNl || "",
            });
        }).catch((error) => {
            handleError(error);
            history.push('/notification-templates');
        });
    }, [id]);

    const handleUpdate = async (values) => {
        try {
            const requestBody = {
                titleEn: values.titleEn,
                bodyEn: values.bodyEn,
                titleNl: values.titleNl,
                bodyNl: values.bodyNl,
            }
            await updateNotificationTemplate(id, requestBody);
            history.push('/notification-templates');
            toast.success("Notification template updated successfully!");
        } catch (err) {
            handleError(err);
        }
    };

    if (!initialValues) return <p>Loading...</p>;

    return (
        <div className="container mt-4">
            <h2 className="mb-4">Update Notification Template</h2>
            <NotificationTemplateForm
                initialValues={initialValues}
                onSubmit={handleUpdate}
                isEditing={true}
            />
        </div>
    );
}

export default EditNotificationTemplatePage;
